import React from 'react';
import classes from "./header.module.css";

const Header = () => {
    return (
        <div className={classes._}>
            <a className={classes.link} href={'servers'}>Сервера</a>
            <a className={classes.link} href={'clients'}>Клиенты</a>
            <a className={classes.link} href={'payments'}>Пополнения</a>
        </div>
    );
};

export default Header;